// ====================================================
// More Templates: https://www.ebenmonney.com/templates
// Email: support@ebenmonney.com
// ====================================================


/*
{ provide: INITIAL_CONFIG, useValue: { document: '<app></app>', url: params.url } },
        { provide: APP_BASE_HREF, useValue: params.baseUrl },
        { provide: 'BASE_URL', useValue: params.origin + params.baseUrl },
        { provide: 'BASE_URL', useValue: params.origin + params.baseUrl },
        { provide: 'ORIGIN_URL', useValue: params.origin + params.baseUrl },
        { provide: 'API_URL', useValue: params.data.apiUrl },
        { provide: 'IDENTITY_URL', useValue: params.data.identityUrl },
        { provide: 'URL_CONFIG', useValue: params.data}
 */

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModuleShared } from './app/app.module.shared';
import { environment } from './environments/environment';
import {appNameFactory, appPathFactory, identityUrlFactory, siteMode} from "./app/app.module.browser";

export function getBaseUrl() {
  let baseurl = document.getElementsByTagName('base')[0].href;
  if(baseurl[baseurl.length - 1] === '/')
    return baseurl.slice(0, -1);
  return baseurl;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
  { provide: 'ORIGIN_URL', useFactory: getBaseUrl , deps: []},
  { provide: 'IDENTITY_URL', useFactory: identityUrlFactory, deps: [] },
  { provide: 'APP_PATH', useFactory: appPathFactory, deps: [] },
  { provide: 'APP_NAME', useFactory: appNameFactory, deps: [] },
  { provide: 'SITE_MODE', useFactory: siteMode, deps: []}
];


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModuleShared)
  .catch(err => console.error(err));
